import { StyleFn } from '..'

export const Flex: StyleFn = () => ({
  root: { display: 'flex' },
  row: { flexDirection: 'row !important' },
  column: { flexDirection: 'column !important' },
  ['row-reverse']: { flexDirection: 'row-reverse !important' },
  ['column-reverse']: { flexDirection: 'column-reverse !important' },
  ['grow-0']: { flexGrow: 0 },
  ['grow-1']: { flexGrow: 1 },
})

export const Justify: StyleFn = () => {
  return {
    ['content-start']: { justifyContent: 'flex-start !important' },
    ['content-end']: { justifyContent: 'flex-end !important' },
    ['content-center']: { justifyContent: 'center !important' },
    ['content-space-between']: {
      justifyContent: 'space-between !important',
    },
    ['content-space-around']: {
      justifyContent: 'space-around !important',
    },
    ['content-space-evenly']: {
      justifyContent: 'space-evenly !important',
    },
  }
}

export const Align: StyleFn = () => ({
  // flex align-items
  ['items-start']: { alignItems: 'flex-start !important' },
  ['items-end']: { alignItems: 'flex-end !important' },
  ['items-center']: { alignItems: 'center !important' },
  ['items-baseline']: { alignItems: 'baseline !important' },
  ['items-stretch']: { alignItems: 'stretch !important' },
  // flex align-content
  ['content-start']: { alignContent: 'flex-start !important' },
  ['content-end']: { alignContent: 'flex-end !important' },
  ['content-center']: { alignContent: 'center !important' },
  ['content-space-between']: { alignContent: 'space-between !important' },
  ['content-space-around']: { alignContent: 'space-around !important' },
  ['content-stretch']: { alignContent: 'stretch !important' },
  // flex align-self
  ['self-start']: { alignSelf: 'flex-start !important' },
  ['self-end']: { alignSelf: 'flex-end !important' },
  ['self-center']: { alignSelf: 'center !important' },
  ['self-baseline']: { alignSelf: 'baseline !important' },
  ['self-stretch']: { alignSelf: 'stretch !important' },
})
